module.exports = __webpack_public_path__ + "img/Loft.6941fe51.png";